import { makeStyles } from '@material-ui/core/styles'
import LinearProgress from '@mui/material/LinearProgress'
import { Box } from '@mui/material'

const StatusBar = ({ statusValues = {} }) => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.progressBarContainer}>
        <Box width={'25%'}>
          <LinearProgress
            data-testid='progress-bar-1'
            variant='determinate'
            value={statusValues.first ?? 0}
            className={classes.linearProgression}
          />
        </Box>
        <Box width={'25%'}>
          <LinearProgress
            data-testid='progress-bar-2'
            variant='determinate'
            value={statusValues.second ?? 0}
            className={classes.linearProgression}
          />
        </Box>
        <Box width={'25%'}>
          <LinearProgress
            data-testid='progress-bar-3'
            variant='determinate'
            value={statusValues.third ?? 0}
            className={classes.linearProgression}
          />
        </Box>
        <Box width={'25%'}>
          <LinearProgress
            data-testid='progress-bar-4'
            variant='determinate'
            value={statusValues.fourth ?? 0}
            className={classes.linearProgression}
          />
        </Box>
      </div>
    </>
  )
}

export default StatusBar
const useStyles = makeStyles({
  progressBarContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
  linearProgression: {
    '&.MuiLinearProgress-root': {
      backgroundColor: '#BCE1EC !important',
      borderRadius: '50px',
    },
    '& .MuiLinearProgress-bar': {
      background: '#4DC3E3 !important',
    },
  },
})
